import { ButtonBoxDangerShapeCompact, ButtonBoxDangerGhostCompact, ButtonBoxDangerShapeField, ButtonBoxDangerGhostField, ButtonBoxPrimaryShapeCompact, ButtonBoxPrimaryGhostCompact, ButtonBoxPrimaryShapeField, ButtonBoxPrimaryGhostField, ButtonBoxSecondaryShapeCompact, ButtonBoxSecondaryGhostCompact, ButtonBoxSecondaryShapeField, ButtonBoxSecondaryGhostField } from './button.styles';
export const SpinnerSizeByButtonSizeMap = {
  compact: 'small',
  field: 'medium'
};
export const ButtonPropsToButtonBoxMap = {
  danger: {
    shape: {
      field: ButtonBoxDangerShapeField,
      compact: ButtonBoxDangerShapeCompact
    },
    ghost: {
      field: ButtonBoxDangerGhostField,
      compact: ButtonBoxDangerGhostCompact
    }
  },
  primary: {
    shape: {
      field: ButtonBoxPrimaryShapeField,
      compact: ButtonBoxPrimaryShapeCompact
    },
    ghost: {
      field: ButtonBoxPrimaryGhostField,
      compact: ButtonBoxPrimaryGhostCompact
    }
  },
  secondary: {
    shape: {
      field: ButtonBoxSecondaryShapeField,
      compact: ButtonBoxSecondaryShapeCompact
    },
    ghost: {
      field: ButtonBoxSecondaryGhostField,
      compact: ButtonBoxSecondaryGhostCompact
    }
  }
};